import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './ProgressBar.css';

const calcValue = (value, min, max) => {
  let v = value;
  if (value >= max) {
    v = max;
  }

  if (value <= min) {
    v = min;
  }

  return Math.abs(((v - min) * 100) / (max - min));
};

const ProgressBar = ({
  color = '',
  value = 0,
  min = 0,
  max = 100,
  className = '',
  ...otherProps
}) => {

  const classes = classNames(
    'ng-ui-widgets',
    'ng-ui-progress-bar',
    className,
  );

  const style = Object.assign({}, {
    width: `${calcValue(value, min, max)}%`,
  }, color ? { backgroundColor: color } : { });

  return (
    <div
      className={classes}
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={min}
      aria-valuemax={max}
      {...otherProps}
    >
      <div
        className="fill"
        style={style}
      />
    </div>
  );
};



ProgressBar.propTypes = {
  color: PropTypes.string,
  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default ProgressBar;